import { PoolerEmploymentTabIdEnum } from '../../models/PoolerEmploymentTabIdEnum';
import { PoolerUser } from '../../models/user';
import { Employment, EmploymentStatusEnum } from '../../models/employment';
import { getPoolerEmploymentsNewTabQuery } from '../employment/getPoolerEmploymentsOpenTabQuery';
import { EmploymentInviteeStatusEnum } from '../../models/employmentInviteeStatusEnum';

export function getPoolerEmploymentsTabQuery(
  tabId: PoolerEmploymentTabIdEnum,
  currentUser: PoolerUser,
): Mongo.Selector<Employment> {
  switch (tabId) {
    case PoolerEmploymentTabIdEnum.NEW:
      return getPoolerEmploymentsNewTabQuery(currentUser);
    case PoolerEmploymentTabIdEnum.ANSWERED:
      return {
        status: EmploymentStatusEnum.OPEN,
        invitees: {
          $elemMatch: {
            userId: currentUser._id,
            hiddenForPooler: { $ne: true },
            status: {
              $in: [
                EmploymentInviteeStatusEnum.AVAILABLE,
                EmploymentInviteeStatusEnum.UNAVAILABLE,
              ],
            },
          },
        },
      };
    case PoolerEmploymentTabIdEnum.BOOKED:
      return {
        status: {
          $in: [
            // archived/canceled jobs show in archived tab
            EmploymentStatusEnum.OPEN,
            EmploymentStatusEnum.CLOSED,
          ],
        },
        invitees: {
          $elemMatch: {
            userId: currentUser._id,
            hiddenForPooler: { $ne: true },
            status: EmploymentInviteeStatusEnum.BOOKED,
          },
        },
      };
    case PoolerEmploymentTabIdEnum.ARCHIVED:
      return {
        $or: [
          // job archived
          {
            status: EmploymentStatusEnum.ARCHIVED,
            invitees: {
              $elemMatch: {
                userId: currentUser._id,
                hiddenForPooler: { $ne: true },
              },
            },
          },
          // invitee declined
          {
            invitees: {
              $elemMatch: {
                userId: currentUser._id,
                status: EmploymentInviteeStatusEnum.DECLINED,
                hiddenForPooler: { $ne: true },
              },
            },
          },
          // job closed with someone else
          {
            status: EmploymentStatusEnum.CLOSED,
            invitees: {
              $elemMatch: {
                userId: currentUser._id,
                hiddenForPooler: { $ne: true },
                status: {
                  $in: [
                    EmploymentInviteeStatusEnum.UNAVAILABLE,
                    EmploymentInviteeStatusEnum.OPEN,
                  ],
                },
              },
            },
          },
        ],
      };
  }
}
